export const initialState = {
  error: null
}
